const cards = [
  {
    id: 1,
    tag: '深度',
    title: '从顶流到过街老鼠：某带货主播的坠落全记录',
    summary: '从年入过亿到全网封杀，他只用了不到半年。我们还原了这位曾经风光无限的头部主播是如何一步步走向深渊的……',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20downward%20spiral%20visual%20metaphor%2C%20broken%20crown%20on%20a%20dark%20stage%2C%20fallen%20spotlight%2C%20scattered%20money%20notes%2C%20moody%20atmosphere%2C%20warm%20crimson%20and%20dark%20amber%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=cards-01-hl&orientation=landscape',
    date: '2026-07-28',
    views: '12.6万',
  },
  {
    id: 2,
    tag: '独家',
    title: '选秀节目背后的资本游戏：谁在操控你的投票',
    summary: '表面上公平公开的投票机制，背后却是资本方的精密算计。我们深挖了选秀产业链中不为人知的利益链条……',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20corporate%20boardroom%20with%20voting%20buttons%20and%20screens%2C%20shadow%20figures%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20warm%20dark%20tones%2C%20editorial%20photography&width=800&height=500&seq=cards-02-hl&orientation=landscape',
    date: '2026-07-27',
    views: '9.8万',
  },
  {
    id: 3,
    tag: '深扒',
    title: '网红圈的"人设工厂"：你所看到的都是精心设计',
    summary: '完美人设的背后是什么？我们潜入多个MCN机构调查，还原了网红从素人到"完美偶像"的完整包装流程……',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20dressing%20room%20with%20mirrors%20and%20costumes%2C%20mannequins%2C%20makeup%20tables%2C%20eerie%20atmosphere%2C%20dramatic%20lighting%2C%20theatrical%20mood%2C%20editorial%20photography%20style&width=800&height=500&seq=cards-03-hl&orientation=landscape',
    date: '2026-07-26',
    views: '8.3万',
  },
  {
    id: 4,
    tag: '追踪',
    title: '某男团队内霸凌事件时间线：从爆料到道歉的72小时',
    summary: '一段后台视频引发的连锁反应：粉丝分裂、公司声明、当事人道歉——我们按分钟梳理了这起事件的完整演变过程……',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20timeline%20visual%20with%20scattered%20newspaper%20clippings%20and%20documents%20on%20a%20dark%20surface%2C%20clock%20showing%20passing%20time%2C%20dramatic%20mood%2C%20editorial%20photography%20style%2C%20warm%20dark%20amber%20tones&width=800&height=500&seq=cards-04-hl&orientation=landscape',
    date: '2026-07-25',
    views: '15.2万',
  },
  {
    id: 5,
    tag: '分析',
    title: '偷税漏税为何屡禁不止？直播行业的税务灰色地带',
    summary: '从雪梨到薇娅，再到近期曝光的头部主播——为何直播带货行业成为偷逃税款的重灾区？我们分析了背后的制度漏洞……',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20financial%20document%20scene%2C%20stacked%20ledgers%20and%20tax%20forms%2C%20red%20seals%20and%20stamps%2C%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20dark%20tones&width=800&height=500&seq=cards-05-hl&orientation=landscape',
    date: '2026-07-24',
    views: '11.4万',
  },
  {
    id: 6,
    tag: '揭秘',
    title: '豪门婚礼变闹剧：富二代婚宴上被曝欠债数十亿',
    summary: '一场斥资千万的奢华婚礼，却在宴席上被债主当场揭穿。这场闹剧背后隐藏的是一个家族企业的巨额债务危机……',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20wedding%20banquet%20hall%20with%20overturned%20chairs%20and%20scattered%20flowers%2C%20broken%20champagne%20glasses%2C%20dramatic%20aftermath%20scene%2C%20warm%20golden%20and%20dark%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=cards-06-hl&orientation=landscape',
    date: '2026-07-23',
    views: '18.7万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              深度扒皮
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card) => (
              <article
                key={card.id}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 text-[10px] font-semibold bg-accent-500 text-background-950 px-2 py-0.5 rounded whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {card.summary}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-400">
                    <span>{card.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {card.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}